"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalComponent = void 0;
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const common_1 = require("@angular/common");
let TerminalComponent = class TerminalComponent {
    constructor() {
        this.lines = (0, core_1.signal)([]);
        this.currentInput = '';
        this.inputEl = core_1.viewChild.required('inputEl');
        this.outputContainer = core_1.viewChild.required('outputContainer');
        this.lines.set([
            { type: 'output', text: 'Windows [Version 11.0.22631.3810]<br>(c) Microsoft Corporation. All rights reserved.<br><br>' }
        ]);
        (0, core_1.afterNextRender)(() => {
            this.focusInput();
        });
    }
    focusInput() {
        this.inputEl().nativeElement.focus();
    }
    onCommand() {
        const command = this.currentInput.trim();
        this.lines.update(l => [...l, { type: 'input', text: command }]);
        if (command) {
            this.executeCommand(command);
        }
        this.currentInput = '';
        this.scrollToBottom();
    }
    executeCommand(command) {
        const parts = command.toLowerCase().split(' ');
        const cmd = parts[0];
        const args = parts.slice(1);
        let output = '';
        switch (cmd) {
            case 'help':
                output = `Available commands:<br>
          &nbsp;&nbsp;help&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Show this help message<br>
          &nbsp;&nbsp;clear&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Clear the terminal screen<br>
          &nbsp;&nbsp;date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Display the current date and time<br>
          &nbsp;&nbsp;echo&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Display a line of text<br>
          &nbsp;&nbsp;whoami&nbsp;&nbsp;&nbsp;&nbsp; Display the current user<br>
        `;
                break;
            case 'clear':
                this.lines.set([]);
                return;
            case 'date':
                output = new Date().toString();
                break;
            case 'echo':
                output = args.join(' ');
                break;
            case 'whoami':
                output = 'User';
                break;
            default:
                output = `'${cmd}' is not recognized as an internal or external command,<br>operable program or batch file.`;
        }
        this.lines.update(l => [...l, { type: 'output', text: output }]);
    }
    scrollToBottom() {
        setTimeout(() => {
            try {
                this.outputContainer().nativeElement.scrollTop = this.outputContainer().nativeElement.scrollHeight;
            }
            catch { }
        }, 0);
    }
};
exports.TerminalComponent = TerminalComponent;
exports.TerminalComponent = TerminalComponent = __decorate([
    (0, core_1.Component)({
        selector: 'app-terminal',
        changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        imports: [forms_1.FormsModule, common_1.CommonModule],
        template: `
    <div class="h-full w-full bg-black text-green-400 font-mono p-2 text-sm" (click)="focusInput()">
      <div #outputContainer class="overflow-y-auto h-full" (scroll)="(0)">
        @for(line of lines(); track $index) {
          <div>
            @if (line.type === 'input') {
              <span class="text-blue-400">C:\\Users\\User> </span><span>{{ line.text }}</span>
            } @else {
              <span [innerHTML]="line.text"></span>
            }
          </div>
        }
        <div class="flex">
          <span class="text-blue-400">C:\\Users\\User> </span>
          <input 
            #inputEl
            type="text" 
            spellcheck="false"
            autocomplete="off"
            class="bg-transparent text-green-400 focus:outline-none flex-grow"
            [(ngModel)]="currentInput"
            (keydown.enter)="onCommand()"
          />
        </div>
      </div>
    </div>
  `
    }),
    __metadata("design:paramtypes", [])
], TerminalComponent);
